<form [formGroup]="invoiceForm" (ngSubmit)="isFormSubmitted = true;onSaveClick()">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{showSaveBtn?'Update':'View'}}</h4>
        <button type="button" class="btn-close" aria-label="Close"(click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Amount Details</div>
                    <div class="card-body">
                        <div *ngIf="showSaveBtn" class="row">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="amtReceived" class="form-label">To Receive<span class="mandatory">*</span></label>
                                    <input type="number" id="amtReceived" class="form-control form-control-sm" formControlName="txtReceived" (keyup)="calculateBalance()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtReceived')?.touched) && invoiceForm.get('txtReceived').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtReceived')?.touched) && invoiceForm.get('txtReceived').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtReceived').errors.pattern">Please enter a valid amount, max 12 digits before and at most 3 decimal places.</span>
                                        <span *ngIf="invoiceForm.get('txtReceived').errors.required">Amount is required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showSaveBtn" class="row">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="amtBalance" class="form-label">To Balance</label>
                                    <input type="number" id="amtBalance" class="form-control form-control-sm" formControlName="txtBal"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || invoiceForm.get('txtBal')?.touched) && invoiceForm.get('txtBal').errors}" >
                                    <div *ngIf="(isFormSubmitted || invoiceForm.get('txtBal')?.touched) && invoiceForm.get('txtBal').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="invoiceForm.get('txtBal').errors.pattern">Please enter a number with up to 10 digits and at most two decimal places.</span>
                                        <span *ngIf="invoiceForm.get('txtBal').errors.required">Must be of 10 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <div class="mb-2">
                                    <span>Total Amount:</span><br>
                                    <span>Received:</span><br>
                                    <span>Balance:</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-2">
                                    <span>{{ cellData.totalamount || 0.00}}</span><br>
                                    <span>{{ cellData.amountreceived }}</span><br>
                                    <span>{{ cellData.amountbalance || 0.00 }}</span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="showSaveBtn" type="submit" class="btn btn-outline-dark" >Save</button>
    </div>
</form>